/* Snuzone Desktop Search Panel — v12.2
   v12.2 (Hardening nach unabhaengiger Header-Pruefung, 28.10.2026):
        - L: close() brach laufende Suchanfragen nicht ab und liess den
          Controller gueltig – spaete Antworten renderten in das geschlossene
          Panel und standen beim naechsten Oeffnen kurz als veraltete Treffer
          da. Jetzt: close() und showIdle() (Begriff geloescht) brechen den
          laufenden Controller ab und setzen ihn auf null, damit current()
          fuer alle offenen Antworten falsch wird. Beim Weitertippen bleibt
          das Debounce-Verhalten bewusst unveraendert (Vorgaenger-Treffer
          stehen, bis die erste neue Antwort da ist).
        - Sonst unveraendert (v12.1).
   v12.1 (Audit-Fixes 27.10.2026, zu Section v19.1):
        - Predictive: resources[limit_scope]=each. Ohne den Parameter gilt
          resources[limit] ueber ALLE Typen zusammen (Shopify-Default "all");
          seit v11 (query+product) war das Limit damit geteilt, mit drei Typen
          konnten Kollektionen komplett fehlen.
        - Typing-State progressiv: Predictive-Antwort rendert sofort, die volle
          Suche haengt Zusatztreffer an, sobald sie da ist (Dedupe per handle,
          keine Umsortierung bereits gezeigter Karten). Reihenfolge = Ankunft;
          in der Praxis ist suggest.json schneller als das Liquid-Template.
        - Fehlerzustand: Scheitern BEIDE Requests technisch (Netz, 429, 5xx),
          zeigt das Panel data-error-label statt "Keine Treffer".
        - Recent: Fallback (serverseitig gerendert) wird nach 250 ms sichtbar,
          wenn Recent noch laedt; Hard-Timeout 3 s per AbortController;
          Antworten von /products/{handle}.js werden schlank in sessionStorage
          gecacht (TTL 5 min) -> zweites Oeffnen instant.
        - showIdle() laedt Recent nach, wenn in dieser Oeffnung noch nicht
          geladen (vorher: Panel mit gefuelltem Feld geoeffnet, Begriff
          geloescht -> beide Idle-Bereiche hidden).
        - Positionierung komplett aus dieser Datei entfernt (positionPanel,
          repositionLoop, resize-Listener). Einziger Eigentuemer ist das
          Inline-Script der Section (Anker #HeaderSearchForm). Der hiesige
          Anker .site-header__search-container war genau das Element, das
          v18.1 als Spalt-Ursache ausgeschlossen hatte.
        - Preis-Normalisierung quellspezifisch: Predictive = Dezimal (String
          oder Zahl), volle Suche / .js = Cents. Geld-Fallback ohne
          Shopify.formatMoney formatiert nach shop.money_format statt fix "€".
        - aria-labels (Wishlist) aus data-label-wishlist (Section-Setting,
          Translate & Adapt) statt hardcodiert DE.
        - Spalten-Limits: Karten pro Reihe aus Breakpoint (>= 1200px: 6 + Spot,
          990-1199px: 5 + Spot, ohne Spot 6); Recent laedt nie mehr Karten als
          in die Reihe passen. Typing: bei Viewport-Hoehe < 1100px max. 5
          Produkte (eine Reihe), damit nichts Unsichtbares geladen wird.
        - bindEvents() nur einmal pro Seite (Guard), kein Listener-Stapel bei
          shopify:section:load. MediaQueryList-Fallback (addListener) ergaenzt.
   v12 (Build R2 "Produkt-Buehne", zu Section v19):
        - Predictive-Request um resources[type]=collection erweitert (gleicher
          suggest.json-Call, kein Zusatz-Request).
        - renderCollections(): Kollektionen zum Suchbegriff in
          [data-snz-collections-list], nach Titellaenge aufsteigend sortiert
          (kuerzester Titel = Elternkollektion zuerst), auf data-collection-limit
          (Default 4) gekuerzt. Erste = .snzs-collink--lead, Rest .snzs-collink.
        - Vorschlaege: Hervorhebung invertiert. Der getippte Teil bleibt 400,
          die Ergaenzung liegt in <span class="snzs-sugg__rest"> (500).
        - .snzs-no-sugg nur noch, wenn Vorschlaege UND Kollektionen leer.
        - View-all-Link liegt in der Kopfzeile der Produktspalte.
        - Spot-Kachel ([data-snz-spot-tile]) wandert zwischen Recent- und
          Fallback-Grid (ein DOM-Knoten).
   v11.1: Overlay-Lookup gescoped (findRoot im eigenen Section-Wrapper).
   v11: Produkt-Treffer als MERGE aus suggest.json (Prefix) + volle Suche
        (Typo-Toleranz), Dedupe per handle. Wishlist-VID lazy via /products/{handle}.js.
   v10: Quick Shop laesst das Panel offen (Proxy-Klick vom Outside-Close ausgenommen).
   Karten = nativer .grid-product-redesign Klon (identisch zur RV-Section),
   Quick-Shop via Proxy-Trigger-Pattern, Wishlist via Swym-API.
   Datei: assets/snuzone-search.js
*/
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var WIDE = window.matchMedia('(min-width: 1200px)');
  var DEBOUNCE_MS = 180;
  var RECENT_FALLBACK_MS = 250;   // Fallback einblenden, wenn Recent so lange laedt
  var RECENT_TIMEOUT_MS = 3000;   // Hard-Timeout fuer Recent-Requests
  var CACHE_TTL_MS = 5 * 60 * 1000;
  var CACHE_PREFIX = 'snzs_pj:';
  var SECTION_WRAPPER_ID = 'shopify-section-snuzone-search-panel';

  var root, panel, overlay;
  var cfg = {};
  var elRecentWrap, elRecentGrid, elFallback, elFallbackGrid, elSpot;
  var elSugWrap, elSugList, elCollWrap, elCollList, elProductsGrid, elEmpty, elViewAll;
  var stateIdle, stateTyping;
  var activeInput = null;
  var debTimer = null;
  var ctrl = null;
  var LOCALE_PREFIX = '';
  var isOpen = false;
  var openSeq = 0;          // Zaehler pro Oeffnung: verwirft Recent-Antworten nach Schliessen
  var idleLoaded = false;   // Recent/Fallback in dieser Oeffnung bereits angestossen
  var suppressClose = false; // Proxy-Klick des Quick Shops nicht als Outside-Click werten

  /* ── Icons (identisch zur RV-Section) ─────────────────────────────── */
  var ICON_HEART = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7z"/></svg>';
  var ICON_ATC = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<circle cx="14" cy="14" r="14" fill="white"/>'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9864 7.62938C12.6556 8.31877 12.4258 9.52248 12.4258 11.5262H11.6036C11.6036 9.49021 11.8324 8.13548 12.2447 7.27637C12.4541 6.83997 12.7187 6.51494 13.04 6.30066C13.3639 6.08462 13.7172 6 14.07 6C14.4228 6 14.7761 6.08462 15.1 6.30066C15.4213 6.51494 15.6859 6.83997 15.8953 7.27637C16.3076 8.13548 16.5363 9.49021 16.5363 11.5262H15.7142C15.7142 9.52248 15.4844 8.31877 15.1535 7.62938C14.9914 7.29153 14.8133 7.0948 14.6425 6.98088C14.4744 6.86872 14.2863 6.8187 14.07 6.8187C13.8537 6.8187 13.6656 6.86872 13.4974 6.98088C13.3267 7.0948 13.1486 7.29153 12.9864 7.62938Z" fill="black"/>'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.00521 9.06998H19.1306L20.1333 19.2858H7.99976L9.00521 9.06998ZM9.75069 9.88868L8.90639 18.4671H19.2269L18.3849 9.88868H9.75069Z" fill="black"/>'
    + '<circle cx="19.7395" cy="19.6952" r="3.2608" fill="white"/>'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M19.4123 21.6518V17.7388H20.0645V21.6518H19.4123Z" fill="black"/>'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.6965 20.0216H17.7835V19.3694H21.6965V20.0216Z" fill="black"/>'
    + '</svg>';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Geld ─────────────────────────────────────────────────────────── */
  function fallbackMoney(cents) {
    var v = Number(cents) / 100;
    if (isNaN(v)) v = 0;
    var fmt = cfg.moneyFormat || '{{amount}}';
    function num(thousands, decimalSep, decimals) {
      var parts = v.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts[0] + decimalSep + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return num(',', '', 0);
        case 'amount_with_comma_separator': return num('.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return num('.', '', 0);
        case 'amount_with_apostrophe_separator': return num("'", '.', 2);
        case 'amount_with_space_separator': return num(' ', ',', 2);
        case 'amount_no_decimals_with_space_separator': return num(' ', '', 0);
        case 'amount_with_period_and_space_separator': return num(' ', '.', 2);
        default: return num(',', '.', 2);
      }
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, cfg.moneyFormat); } catch (e) {}
    }
    return fallbackMoney(cents);
  }

  /* v12.1: Normalisierung quellspezifisch, nicht nach JS-Datentyp.
     Predictive (suggest.json) liefert Dezimalbetraege ("19.99"); volle Suche
     (search.ajax.liquid) und /products/{handle}.js liefern Cents. */
  function decimalToCents(v) {
    if (v == null || v === '') return 0;
    var n;
    if (typeof v === 'number') {
      n = v;
    } else {
      var s = String(v).replace(/[^\d.,]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
      n = parseFloat(s);
    }
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function centsToCents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return Math.round(v);
    var n = parseInt(String(v).replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  function resize540(src) {
    if (!src) return '';
    return String(src).replace(/(\.[^.\/]+)(\?[^?]*)?$/, '_540x$1$2');
  }

  function hasTagCI(tags, tag) {
    if (!tag || !Array.isArray(tags)) return false;
    var t = String(tag).toLowerCase();
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === t) return true;
    }
    return false;
  }

  /* ── Spalten-Logik (v12.1) ─────────────────────────────────────────
     >= 1200px: 6 Karten + Spot (7 Spalten) · 990-1199px: 5 Karten + Spot
     (6 Spalten, Section-CSS blendet die 6. Karte aus) · ohne Spot: 6. */
  function cardsPerRow() {
    if (!cfg.hasSpot) return 6;
    return WIDE.matches ? 6 : 5;
  }
  function isShallow() { return window.innerHeight < 1100; }
  function effectiveRecentLimit() { return Math.min(cfg.recentLimit, cardsPerRow()); }
  function effectiveProductLimit() {
    /* Section-CSS clippt unter 1100px Hoehe auf eine Reihe (5 Spalten) */
    return isShallow() ? Math.min(cfg.productLimit, 5) : cfg.productLimit;
  }

  /* ── Normalisierung der beiden Produkt-Quellen ────────────────────── */

  /* Volle Suche (templates/search.ajax.liquid v3): Cents, Boolean isNew */
  function normFull(p) {
    var priceCents = centsToCents(p.price);
    var capCents = centsToCents(p.cap);
    return {
      handle: p.handle || handleFromUrl(p.url),
      url: p.url || '',
      image: p.image || '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (capCents > priceCents) ? capCents : null,
      id: p.id || '',
      vid: p.vid || '',
      available: p.available !== false,
      isNew: p.isNew === true
    };
  }

  /* Predictive (suggest.json): Dezimalpreise, keine Varianten-ID */
  function normSuggest(p) {
    var priceCents = decimalToCents(p.price);
    var capCents = decimalToCents(p.compare_at_price_max);
    var img = p.image || (p.featured_image && p.featured_image.url) || '';
    return {
      handle: p.handle || handleFromUrl(p.url),
      url: p.url || '',
      image: img ? resize540(img) : '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (capCents > priceCents) ? capCents : null,
      id: p.id || '',
      vid: '', // suggest.json liefert keine Varianten-ID -> lazy beim Wishlist-Klick
      available: p.available !== false,
      isNew: hasTagCI(p.tags, cfg.newTag)
    };
  }

  /* ── Native Karte (Markup-Klon von custom-product-grid-item-clean,
        identisch zur RV-Section, ohne Reorder-Signale) ─────────────── */
  function cardHTML(o) {
    var url = o.url || '#';
    var hasSale = typeof o.capCents === 'number' && o.capCents > o.priceCents;
    var salePct = hasSale ? Math.round((1 - o.priceCents / o.capCents) * 100) : 0;

    var tags = '';
    if (hasSale && salePct > 0) {
      tags += '<div class="grid-product__tag grid-product__tag--sale">' + esc(cfg.saleLabel) + ' <span data-percent-pack>-' + salePct + '%</span></div>';
    }
    if (o.isNew && cfg.showBadge) {
      tags += '<div class="grid-product__tag grid-product__tag--new">' + esc(cfg.badgeLabel) + '</div>';
    }

    /* v11: Herz auch ohne vid rendern (Suggest-Treffer) — VID wird beim
       ersten Klick lazy via /products/{handle}.js nachgeladen */
    var heart = '';
    if (cfg.showHeart && o.id) {
      heart = '<button type="button"'
        + ' class="wishlist-button wishlist-button--icon"'
        + ' data-snz-wl'
        + ' data-product-id="' + o.id + '"'
        + ' data-variant-id="' + (o.vid || '') + '"'
        + ' data-product-url="' + esc(url) + '"'
        + ' aria-label="' + esc(cfg.wishlistLabel) + '">'
        + ICON_HEART
        + '</button>';
    }

    var props = '';
    if (o.mg) {
      props = '<ul class="grid-product__properties no-bullets">'
        + '<li>' + esc(o.mg) + '</li>'
        + '</ul>';
    }

    var price;
    if (hasSale) {
      price = '<span class="grid-regular-price">' + formatMoney(o.priceCents) + '</span>'
        + '<span class="grid-compare-price">' + formatMoney(o.capCents) + '</span>';
    } else {
      price = '<span>' + formatMoney(o.priceCents) + '</span>';
    }

    /* Bild: Positionierung inline — themeunabhängig, kein Clipping durch 0-Höhe-Wrapper */
    var image = '<div class="image-wrap" style="position: relative; height: 0; padding-bottom: 100%; overflow: hidden;">'
      + (o.image
        ? '<img class="grid-product__image" src="' + esc(o.image) + '" alt="' + esc(o.title) + '" loading="lazy"'
          + ' style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; opacity: 1; display: block;">'
        : '')
      + '</div>';

    return '<div class="custom-grid-product grid-product grid-product-redesign"'
      + ' data-product-handle="' + esc(o.handle || '') + '">'
      + '<div class="grid-product__content">'

      + '<div class="grid-product__tag-list grid-product__tag-list--top">'
      + tags
      + heart
      + '</div>'

      + '<a href="' + esc(url) + '" class="grid-product__link">'
      + '<div class="grid-product__image-mask">'
      + image
      + '</div>'
      + '</a>'

      + '<div class="grid-product__meta">'
      + '<div class="grid-product__meta-part">'
      + props
      + '<a href="' + esc(url) + '" class="grid-product__title">' + esc(o.title) + '</a>'
      + (o.sub ? '<div class="grid-product__vendor">' + esc(o.sub) + '</div>' : '')
      + '<div class="product-price">' + price + '</div>'
      + '</div>'
      + '</div>'

      + (o.handle
        ? '<div class="mobile-add-to-cart pulse" data-mobile-add-to-cart data-handle="' + esc(o.handle) + '">' + ICON_ATC + '</div>'
        : '')

      + '</div>'
      + '</div>';
  }

  /* ── Spot-Kachel (v12): ein DOM-Knoten, wandert ins aktive Grid ───── */
  function placeSpot(grid) {
    if (!elSpot || !grid) return;
    if (elSpot.parentNode !== grid) grid.appendChild(elSpot);
  }

  /* ── Produkt-Cache (v12.1, sessionStorage, schlank) ───────────────── */
  function slimProduct(p) {
    return {
      handle: p.handle,
      title: p.title,
      id: p.id,
      price: p.price,
      compare_at_price: p.compare_at_price,
      featured_image: p.featured_image || (p.images && p.images[0]) || '',
      tags: Array.isArray(p.tags) ? p.tags : [],
      vid: (p.variants && p.variants[0]) ? p.variants[0].id : ''
    };
  }

  function cacheGet(handle) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + handle);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.p || (Date.now() - obj.t) > CACHE_TTL_MS) return null;
      return obj.p;
    } catch (e) { return null; }
  }

  function cacheSet(handle, slim) {
    try { sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({ t: Date.now(), p: slim })); } catch (e) {}
  }

  function fetchProductSlim(handle, signal) {
    var cached = cacheGet(handle);
    if (cached) return Promise.resolve(cached);
    return fetch(LOCALE_PREFIX + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', signal: signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.handle) return null;
        var slim = slimProduct(p);
        cacheSet(handle, slim);
        return slim;
      })
      .catch(function () { return null; });
  }

  /* ── Recently Viewed ──────────────────────────────────────────────── */
  function readRV() {
    var raw;
    try { raw = localStorage.getItem('rv_products'); } catch (e) { return []; }
    if (!raw) return [];
    var arr;
    try { arr = JSON.parse(raw); } catch (e) { return []; }
    if (!Array.isArray(arr)) return [];
    return arr.map(function (it) {
      if (typeof it === 'string') return { handle: it, strength: null };
      if (it && it.handle) return it;
      return null;
    }).filter(Boolean);
  }

  function loadRecent() {
    var myOpen = openSeq;
    idleLoaded = true;

    var items = readRV().slice(0, effectiveRecentLimit());
    if (!items.length) { showFallback(); return; }

    var rCtrl = window.AbortController ? new AbortController() : null;
    var signal = rCtrl ? rCtrl.signal : undefined;
    var settled = false;

    /* Hard-Timeout: haengende Requests brechen ab, Promise.all loest mit nulls auf */
    var killTimer = setTimeout(function () { if (rCtrl) { try { rCtrl.abort(); } catch (e) {} } }, RECENT_TIMEOUT_MS);
    /* Nach 250 ms ohne Antwort: Fallback sichtbar, Recent ersetzt ihn spaeter */
    var fbTimer = setTimeout(function () {
      if (!settled && openSeq === myOpen && isOpen) showFallback();
    }, RECENT_FALLBACK_MS);

    var fetches = items.map(function (it) {
      return fetchProductSlim(it.handle, signal).then(function (p) { return p ? { p: p, item: it } : null; });
    });

    Promise.all(fetches).then(function (results) {
      settled = true;
      clearTimeout(killTimer);
      clearTimeout(fbTimer);
      if (openSeq !== myOpen || !isOpen) return; // inzwischen geschlossen oder neu geoeffnet

      var html = '';
      results.forEach(function (res) {
        if (!res) return;
        var p = res.p;
        var it = res.item;
        html += cardHTML({
          handle: p.handle,
          url: LOCALE_PREFIX + '/products/' + p.handle,
          image: resize540(p.featured_image || ''),
          title: p.title,
          sub: it.strength || '',
          mg: it.mg || '',
          priceCents: centsToCents(p.price),
          capCents: (p.compare_at_price && p.compare_at_price > p.price) ? centsToCents(p.compare_at_price) : null,
          id: p.id,
          vid: p.vid || '',
          isNew: hasTagCI(p.tags, cfg.newTag)
        });
      });
      if (!html) { showFallback(); return; }
      elRecentGrid.innerHTML = html;
      placeSpot(elRecentGrid); // Spot als letzte Kachel hinter den Karten
      if (elRecentWrap) elRecentWrap.hidden = false;
      if (elFallback) elFallback.hidden = true;
      markWishlist(elRecentGrid);
    });
  }

  function showFallback() {
    placeSpot(elFallbackGrid); // Spot zurueck ins Fallback-Grid
    if (elRecentWrap) elRecentWrap.hidden = true;
    if (elFallback) elFallback.hidden = false;
    markWishlist(elFallback);
  }

  /* ── Vorschlaege (suggest.json) ───────────────────────────────────── */

  /* v12: Hervorhebung invertiert. Getippter Teil = normal (400), Ergaenzung
     = .snzs-sugg__rest (500). Aufgebaut aus q.text + Query, vollstaendig
     escaped – styled_text/<b> der API wird nicht verwendet. */
  function suggMarkup(text, q) {
    var t = String(text || '');
    var ql = String(q || '').toLowerCase();
    var idx = ql ? t.toLowerCase().indexOf(ql) : -1;
    if (idx < 0) return '<span class="snzs-sugg__rest">' + esc(t) + '</span>';
    var before = t.slice(0, idx);
    var hit = t.slice(idx, idx + ql.length);
    var after = t.slice(idx + ql.length);
    return (before ? '<span class="snzs-sugg__rest">' + esc(before) + '</span>' : '')
      + esc(hit)
      + (after ? '<span class="snzs-sugg__rest">' + esc(after) + '</span>' : '');
  }

  function renderSuggestions(queries, q) {
    if (!elSugWrap || !elSugList) return false;
    if (!queries || !queries.length) {
      elSugWrap.hidden = true;
      elSugList.innerHTML = '';
      return false;
    }
    elSugWrap.hidden = false;
    elSugList.innerHTML = queries.map(function (item) {
      var term = item.text || (item.styled_text ? item.styled_text.replace(/<[^>]+>/g, '') : '');
      var url = LOCALE_PREFIX + '/search?q=' + encodeURIComponent(term) + '&type=product';
      return '<a href="' + esc(url) + '" class="snzs-link snzs-sugg">' + suggMarkup(term, q) + '</a>';
    }).join('');
    return true;
  }

  /* ── Kollektionen (v12, suggest.json) ─────────────────────────────── */
  function renderCollections(list) {
    if (!elCollWrap || !elCollList) return false;
    var arr = Array.isArray(list) ? list.slice() : [];
    arr = arr.filter(function (c) { return c && c.title && c.url; });
    if (!arr.length) {
      elCollWrap.hidden = true;
      elCollList.innerHTML = '';
      return false;
    }
    /* Kuerzester Titel zuerst = Elternkollektion vor Varianten (Cuba -> Cuba Black) */
    arr.sort(function (a, b) { return String(a.title).length - String(b.title).length; });
    arr = arr.slice(0, cfg.collectionLimit);

    elCollList.innerHTML = arr.map(function (c, i) {
      var cls = i === 0 ? 'snzs-link snzs-collink snzs-collink--lead' : 'snzs-link snzs-collink';
      return '<a href="' + esc(c.url) + '" class="' + cls + '">' + esc(c.title) + '</a>';
    }).join('');
    elCollWrap.hidden = false;
    return true;
  }

  /* Linke Spalte nur ausblenden, wenn Vorschlaege UND Kollektionen leer */
  function updateLeftCol(hasSugg, hasColl) {
    if (!stateTyping) return;
    if (hasSugg || hasColl) stateTyping.classList.remove('snzs-no-sugg');
    else stateTyping.classList.add('snzs-no-sugg');
  }

  /* ── Produkte: Leer-/Fehlerzustand ────────────────────────────────── */
  function showEmpty(label) {
    if (elProductsGrid) elProductsGrid.innerHTML = '';
    if (elEmpty) {
      elEmpty.textContent = label;
      elEmpty.hidden = false;
    }
  }

  function setViewAll(q) {
    if (!elViewAll) return;
    if (!q) { elViewAll.textContent = ''; elViewAll.removeAttribute('href'); return; }
    elViewAll.textContent = (cfg.viewAllLabel || 'Alle Ergebnisse für „[query]“ ansehen').replace('[query]', q);
    elViewAll.setAttribute('href', LOCALE_PREFIX + '/search?q=' + encodeURIComponent(q) + '&type=product');
  }

  /* ── Wishlist (Swym-API direkt, native .added/.heart-pulse States) ── */
  function swymReady(cb) {
    if (window._swat) { cb(window._swat); return; }
    if (window.SwymCallbacks) {
      window.SwymCallbacks.push(cb);
    } else {
      window.SwymCallbacks = [cb];
    }
  }

  function markWishlist(scope) {
    if (!cfg.showHeart || !scope) return;
    var buttons = scope.querySelectorAll('[data-snz-wl]');
    if (!buttons.length) return;
    swymReady(function (swat) {
      try {
        swat.fetch(function (items) {
          if (!Array.isArray(items)) return;
          var inList = {};
          items.forEach(function (i) { if (i && i.empi) inList[String(i.empi)] = true; });
          buttons.forEach(function (btn) {
            if (inList[btn.getAttribute('data-product-id')]) btn.classList.add('added');
          });
        });
      } catch (e) {}
    });
  }

  function doWishlist(btn) {
    swymReady(function (swat) {
      var payload = {
        epi: parseInt(btn.getAttribute('data-variant-id'), 10),
        empi: parseInt(btn.getAttribute('data-product-id'), 10),
        du: window.location.origin + btn.getAttribute('data-product-url')
      };
      try {
        if (btn.classList.contains('added')) {
          swat.removeFromWishList(payload, function () {
            btn.classList.remove('added');
          });
        } else {
          swat.addToWishList(payload, function () {
            btn.classList.add('added', 'heart-pulse');
            setTimeout(function () { btn.classList.remove('heart-pulse'); }, 450);
          });
        }
      } catch (err) {}
    });
  }

  /* v11: Suggest-Treffer haben keine Varianten-ID — beim ersten Klick
     lazy via /products/{handle}.js nachladen, dann normaler Flow */
  function onWishlistClick(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (vid && vid !== '') { doWishlist(btn); return; }

    var handle = handleFromUrl(btn.getAttribute('data-product-url'));
    if (!handle) return;
    fetchProductSlim(handle).then(function (p) {
      if (p && p.vid) {
        btn.setAttribute('data-variant-id', p.vid);
        doWishlist(btn);
      }
    });
  }

  /* ── Quick-Shop (delegiert, Proxy-Trigger-Pattern) ────────────────
     Root Cause: der native Handler (picoapp ProductItem) bindet nur beim
     initialen app.mount() — die Panel-Karten entstehen später. Fix: ein
     bereits gemounteter nativer Trigger (außerhalb Panel + RV-Track) wird
     als Proxy geklickt; data-handle wird für den synchronen Klick-Moment
     getauscht → exakt der native Flow inkl. app.mount().
     Das Panel BLEIBT OFFEN (Kunde kann weiter aus den Vorschlaegen kaufen);
     der synthetische Proxy-Klick liegt ausserhalb des Overlays und wird
     deshalb per suppressClose-Flag vom Outside-Close ausgenommen.
     Fallback: Flow-Replikation. */
  function triggerQuickShop(handle) {
    var proxy = null;
    var candidates = document.querySelectorAll('[data-mobile-add-to-cart]');
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c.closest('.snzs-overlay') && !c.closest('.rv-track')) { proxy = c; break; }
    }

    if (proxy) {
      var originalHandle = proxy.getAttribute('data-handle');
      proxy.setAttribute('data-handle', handle);
      suppressClose = true;
      try { proxy.click(); } finally { suppressClose = false; }
      if (originalHandle !== null) {
        proxy.setAttribute('data-handle', originalHandle);
      } else {
        proxy.removeAttribute('data-handle');
      }
      return;
    }

    /* Fallback: nativen Flow replizieren (ohne app.mount-Garantie) */
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || (LOCALE_PREFIX + '/');
    fetch(rootPath + 'products/' + handle + '?view=ajax-product')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var modal = document.querySelector('.ModalForm');
        if (!modal) return;
        modal.innerHTML = html;
        modal.classList.add('active');

        var mClose = document.querySelector('[data-close-popup]');
        if (mClose) {
          mClose.addEventListener('click', function () {
            modal.classList.add('close-animation');
            setTimeout(function () {
              modal.classList.remove('close-animation');
              modal.classList.remove('active');
            }, 400);
            setTimeout(function () {
              var popup = document.querySelector('.product-custom-popup');
              if (popup) popup.remove();
            }, 500);
          });
        }

        if (window.app && typeof window.app.mount === 'function') {
          try { window.app.mount(); } catch (err) {}
        }
      })
      .catch(function () {});
  }

  function bindCardActions() {
    if (overlay.getAttribute('data-snz-actions') === '1') return;
    overlay.setAttribute('data-snz-actions', '1');

    overlay.addEventListener('click', function (e) {
      var wl = e.target.closest && e.target.closest('[data-snz-wl]');
      if (wl && overlay.contains(wl)) {
        e.preventDefault();
        e.stopPropagation();
        onWishlistClick(wl);
        return;
      }
      var atc = e.target.closest && e.target.closest('[data-mobile-add-to-cart]');
      if (atc && overlay.contains(atc)) {
        e.preventDefault();
        e.stopPropagation();
        var handle = atc.getAttribute('data-handle');
        if (handle) triggerQuickShop(handle);
      }
    });
  }

  /* v12.2 (L): laufende Suchanfrage verwerfen – Controller abbrechen UND
     auf null setzen, damit current() fuer alle offenen Antworten falsch wird */
  function abortSearch() {
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = null;
  }

  /* ── State-Wechsel ────────────────────────────────────────────────── */
  function showIdle() {
    abortSearch(); /* v12.2 (L): Begriff geloescht – keine Typing-Antwort mehr annehmen */
    if (stateIdle) stateIdle.hidden = false;
    if (stateTyping) stateTyping.hidden = true;
    /* v12.1: Idle garantiert Recent ODER Fallback – auch nach Loeschen des Begriffs */
    if (!idleLoaded) loadRecent();
  }
  function showTyping() {
    if (stateIdle) stateIdle.hidden = true;
    if (stateTyping) stateTyping.hidden = false;
  }

  function onType(q) {
    q = (q || '').trim();
    if (debTimer) clearTimeout(debTimer);
    if (q.length < 1) { showIdle(); return; }
    showTyping();
    debTimer = setTimeout(function () { runPredictive(q); }, DEBOUNCE_MS);
  }

  /* ── Predictive (v11 Merge, v12 Kollektionen, v12.1 progressiv) ────── */
  function runPredictive(q) {
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = (window.AbortController ? new AbortController() : null);
    var myCtrl = ctrl;
    var signal = ctrl ? ctrl.signal : undefined;
    function current() { return ctrl === myCtrl; }

    /* Zustand dieser Anfrage */
    var shown = {};
    var shownCount = 0;
    var rendered = false;     // erste Karten dieser Anfrage im DOM
    var sugDone = false, fullDone = false;
    var sugFailed = false, fullFailed = false;
    var cap = effectiveProductLimit();

    function appendProducts(list) {
      if (!elProductsGrid) return;
      var free = cap - shownCount;
      if (free <= 0 || !list.length) return;
      var html = '';
      list.slice(0, free).forEach(function (o) {
        shown[o.handle] = 1;
        shownCount++;
        html += cardHTML(o);
      });
      if (!html) return;
      if (!rendered) { elProductsGrid.innerHTML = html; rendered = true; }
      else { elProductsGrid.insertAdjacentHTML('beforeend', html); }
      if (elEmpty) elEmpty.hidden = true;
      markWishlist(elProductsGrid);
    }

    function normList(arr, norm) {
      var out = [];
      arr.forEach(function (p) {
        var o = norm(p);
        if (o.handle && !shown[o.handle] && !out.some(function (x) { return x.handle === o.handle; })) out.push(o);
      });
      out.sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
      return out;
    }

    function finish() {
      if (!current() || !(sugDone && fullDone)) return;
      if (shownCount === 0) {
        showEmpty((sugFailed && fullFailed) ? cfg.errorLabel : cfg.emptyLabel);
      }
    }

    /* 1) Volle Suche: Typo-Toleranz/Relaxation. options[prefix]=last bleibt
       im Request (harmlos; greift automatisch wieder, falls Shopify die
       Prefix-Regression behebt). null = technischer Fehler. */
    var fullP = fetch(
      LOCALE_PREFIX + '/search?q=' + encodeURIComponent(q)
        + '&type=product&options[prefix]=last&view=ajax',
      { credentials: 'same-origin', signal: signal }
    )
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (text) {
        if (text == null) return null;
        try { var j = JSON.parse(text); return Array.isArray(j) ? j : []; } catch (e) { return null; }
      })
      .catch(function () { return null; });

    /* 2) Predictive-Engine: Prefix-Matching (Produkte) + Query-Vorschlaege
       + Kollektionen — ein Request. limit_scope=each: Limit gilt pro Typ. */
    var sugLimit = Math.max(cfg.queryLimit, Math.min(cfg.productLimit, 10), cfg.collectionLimit);
    var sugP = fetch(
      LOCALE_PREFIX + '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=query,product,collection'
        + '&resources[limit]=' + sugLimit
        + '&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=last',
      { credentials: 'same-origin', signal: signal }
    )
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });

    /* Progressiv: wer zuerst antwortet, rendert zuerst; der andere ergaenzt. */
    sugP.then(function (sug) {
      if (!current()) return;
      sugDone = true;
      if (!sug || !sug.resources) {
        sugFailed = true;
        updateLeftCol(false, false);
      } else {
        var results = sug.resources.results || {};
        var hasSugg = renderSuggestions((results.queries || []).slice(0, cfg.queryLimit), q);
        var hasColl = renderCollections(results.collections || []);
        updateLeftCol(hasSugg, hasColl);
        appendProducts(normList(results.products || [], normSuggest));
      }
      setViewAll(q);
      finish();
    });

    fullP.then(function (full) {
      if (!current()) return;
      fullDone = true;
      if (full === null) {
        fullFailed = true;
      } else {
        appendProducts(normList(full, normFull));
      }
      setViewAll(q);
      finish();
    });
  }

  /* ── Open / Close (Positionierung: Inline-Script der Section) ─────── */
  function open() {
    if (!DESKTOP.matches) return;
    if (isOpen) return;
    isOpen = true;
    openSeq++;
    idleLoaded = false;
    overlay.style.display = 'block';
    overlay.classList.add('snzs-open');
    var val = activeInput ? activeInput.value : '';
    if (val && val.trim().length) { onType(val); } else { showIdle(); }
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    idleLoaded = false;
    overlay.style.display = 'none';
    overlay.classList.remove('snzs-open');
    if (debTimer) clearTimeout(debTimer);
    abortSearch(); /* v12.2 (L): keine spaeten Antworten ins geschlossene Panel */
  }

  function onMqChange(m) { if (!m.matches) close(); }

  function bindEvents() {
    /* v12.1: globale Listener nur einmal pro Seite – shopify:section:load
       ruft init() erneut auf, die Listener greifen auf die Modul-Variablen
       (overlay etc.) zu und bleiben damit gueltig. */
    if (window.__snzsEventsBound) return;
    window.__snzsEventsBound = true;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('.js-search-header');
      if (opener) { setTimeout(open, 0); return; }
      var closer = e.target.closest && e.target.closest('.js-search-header-close');
      if (closer) { close(); return; }
      if (isOpen) {
        if (suppressClose) return;
        var inOverlay = overlay.contains(e.target);
        var inSearch = e.target.closest && e.target.closest('.site-header__search-container, .js-search-header');
        /* Quick-Shop-Modal gehoert zum Kaufvorgang – Panel offen lassen */
        var inModal = e.target.closest && e.target.closest('.ModalForm, .product-custom-popup');
        if (!inOverlay && !inSearch && !inModal) close();
      }
    }, true);

    document.addEventListener('focusin', function (e) {
      var inp = e.target.closest && e.target.closest('.site-header__search-input');
      if (inp) { activeInput = inp; setTimeout(open, 0); }
    });

    document.addEventListener('input', function (e) {
      var inp = e.target.closest && e.target.closest('.site-header__search-input');
      if (!inp) return;
      activeInput = inp;
      if (!isOpen) open();
      onType(inp.value);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });

    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onMqChange);
    else if (DESKTOP.addListener) DESKTOP.addListener(onMqChange);
  }

  /* ── Init ─────────────────────────────────────────────────────────── */
  function readCfg() {
    cfg.recentLimit = parseInt(root.getAttribute('data-recent-limit'), 10) || 6;
    cfg.productLimit = parseInt(root.getAttribute('data-product-limit'), 10) || 5;
    cfg.queryLimit = parseInt(root.getAttribute('data-query-limit'), 10) || 4;
    cfg.collectionLimit = parseInt(root.getAttribute('data-collection-limit'), 10) || 4;
    cfg.newTag = root.getAttribute('data-new-tag') || 'neu';
    cfg.badgeLabel = root.getAttribute('data-badge-label') || 'Neu';
    cfg.showBadge = root.getAttribute('data-show-badge') !== 'false';
    cfg.showHeart = root.getAttribute('data-show-heart') === 'true';
    cfg.viewAllLabel = root.getAttribute('data-viewall-label') || 'Alle Ergebnisse für „[query]“ ansehen';
    cfg.moneyFormat = root.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';
    cfg.saleLabel = root.getAttribute('data-sale-label') || 'Sale';
    cfg.wishlistLabel = root.getAttribute('data-label-wishlist') || 'Zur Wunschliste hinzufügen';
    cfg.errorLabel = root.getAttribute('data-error-label') || 'Suche gerade nicht erreichbar.';
    cfg.emptyLabel = (elEmpty && elEmpty.textContent.trim()) || 'Keine Treffer.';
    cfg.hasSpot = !!elSpot;
    LOCALE_PREFIX = (root.getAttribute('data-locale-root') || '').replace(/\/$/, '');
  }

  /* v11.1: Overlay nur innerhalb der eigenen Section suchen.
     Fallback (Overlay bereits an den Body verschoben, z. B. nach einem
     frueheren Init): Klasse UND Attribut muessen passen. Nie dokumentweit
     nur per Attribut — das adoptiert fremde Elemente anderer Sections. */
  function findRoot() {
    var wrap = document.getElementById(SECTION_WRAPPER_ID);
    var el = wrap ? wrap.querySelector('[data-snz-search]') : null;
    if (!el) el = document.querySelector('.snzs-overlay[data-snz-search]');
    return el;
  }

  function init() {
    root = findRoot();
    if (!root) return;
    overlay = root;
    panel = root.querySelector('.snzs-panel');

    stateIdle = root.querySelector('[data-snz-state="idle"]');
    stateTyping = root.querySelector('[data-snz-state="typing"]');
    elRecentWrap = root.querySelector('[data-snz-recent]');
    elRecentGrid = root.querySelector('[data-snz-recent-grid]');
    elFallback = root.querySelector('[data-snz-fallback]');
    elFallbackGrid = root.querySelector('[data-snz-fallback-grid]');
    elSpot = root.querySelector('[data-snz-spot-tile]');
    elSugWrap = root.querySelector('[data-snz-suggestions]');
    elSugList = root.querySelector('[data-snz-suggestions-list]');
    elCollWrap = root.querySelector('[data-snz-collections]');
    elCollList = root.querySelector('[data-snz-collections-list]');
    elProductsGrid = root.querySelector('[data-snz-products-grid]');
    elEmpty = root.querySelector('[data-snz-empty]');
    elViewAll = root.querySelector('[data-snz-viewall]');

    readCfg();

    isOpen = false;
    idleLoaded = false;
    overlay.style.display = 'none';
    overlay.classList.remove('snzs-open');

    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

    bindCardActions();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.id === SECTION_WRAPPER_ID) {
      init();
    }
  });
})();